/*
 * @Descripttion: 车载设备管理接口
 * @Date: 2026-09-16
 */
import service from '@/utils/request'

// 列表数据查询
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/device/terminal/page',
    data: params
  })

// 企业名称下拉框
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })

// 设备型号列表（来源：设备产品维护）
export const getMaintainList = (params: any) =>
  service.request({
    method: 'post',
    url: '/device/maintain/page',
    data: params
  })

// 设备厂商列表
export const getDeviceFactoryList = (params: any) =>
  service.request({
    method: 'post',
    url: '/device/factory/list',
    data: params
  })

// 设备型号列表（按厂商）
export const getDeviceMaintainList = (params: any) =>
  service.request({
    method: 'post',
    url: '/device/maintain/list',
    data: params
  })

// 批量设定管控模式
export const setControlMode = (params: any) =>
  service.request({
    method: 'post',
    url: '/device/terminal/setControlMode',
    data: params
  })

// 批量移除设备
export const removeTerminal = (params: any) =>
  service.request({
    method: 'post',
    url: '/device/terminal/removeBatch',
    data: params
  })
